
import RolePermissions from "../crud/rolePermissions";

import PDF from "../crud/pdf";
import Auth from "../auth";

import Users from "../users";
import Files from "../crud/files";
import ExportCsvTasks from "../crud/exportCsvTasks";
import RolesActionsPermissions from "../crud/rolesActionsPermissions";
import Roles from "../crud/roles";
import PublicCountries from "../crud/publicCountries";
import PublicCurrencies from "../crud/publicCurrencies";
import PublicCurrencyRateSources from "../crud/publicCurrencyRateSources";
import PublicCurrentCurrencyRates from "../crud/publicCurrentCurrencyRates";
import PublicCurrencyRates from "../crud/publicCurrencyRates";
import PublicBanks from "../crud/publicBanks";
import PublicAgents from "../crud/publicAgents";
import PublicGatewayRules from "../crud/publicGatewayRules";
import PublicWalletRules from "../crud/publicWalletRules";
import PublicGatewayApis from "../crud/publicGatewayApis";
import PublicTgBots from "../crud/publicTgBots";
import PublicTgUnknownChats from "../crud/publicTgUnknownChats";
import PublicTgSessions from "../crud/publicTgSessions";
import PublicTgSessionChats from "../crud/publicTgSessionChats";
import PublicTgSessionMessages from "../crud/publicTgSessionMessages";
import PublicGateways from "../crud/publicGateways";
import PublicGatewaySettings from "../crud/publicGatewaySettings";
import PublicScraperScenarios from "../crud/publicScraperScenarios";
import PublicProxyLists from "../crud/publicProxyLists";
import PublicProxies from "../crud/publicProxies";
import PublicMerchants from "../crud/publicMerchants";
import PublicMerchantTerminals from "../crud/publicMerchantTerminals";
import PublicMerchantTerminalBalances from "../crud/publicMerchantTerminalBalances";
import PublicWallets from "../crud/publicWallets";
import PublicCommissions from "../crud/publicCommissions";
import PublicAppeals from "../crud/publicAppeals";
import PublicAppealHasComments from "../crud/publicAppealHasComments";
import PublicAppealHasDocuments from "../crud/publicAppealHasDocuments";
import PayinInstances from "../crud/payinInstances";
import PayinEvents from "../crud/payinEvents";
import PayoutInstances from "../crud/payoutInstances";
import PayoutEvents from "../crud/payoutEvents";
import PayoutDocuments from "../crud/payoutDocuments";
import CallbackprocessorUrlCallbacks from "../crud/callbackprocessorUrlCallbacks";
import AccountingSystemAccounts from "../crud/accountingSystemAccounts";
import AccountingExternalTransactions from "../crud/accountingExternalTransactions";
import AccountingGatewayTransactions from "../crud/accountingGatewayTransactions";
import AccountingWalletTransfers from "../crud/accountingWalletTransfers";
import AccountingGatewayWalletTransfers from "../crud/accountingGatewayWalletTransfers";
import AccountingSystemTransactions from "../crud/accountingSystemTransactions";
import AccountingExpensesTransactions from "../crud/accountingExpensesTransactions";
import AccountingRevenueTransactions from "../crud/accountingRevenueTransactions";



const ServerConfig = {
    auth: Auth,
    users: Users,
    rolePermissions: RolePermissions,
    PDF: PDF,
    files: Files,
    roles: Roles,
    rolesActionsPermissions: RolesActionsPermissions,
    exportCsvTasks: ExportCsvTasks,
    publicCountries: PublicCountries,
    publicCurrencies: PublicCurrencies,
    publicCurrencyRateSources: PublicCurrencyRateSources,
    publicCurrentCurrencyRates: PublicCurrentCurrencyRates,
    publicCurrencyRates: PublicCurrencyRates,
    publicBanks: PublicBanks,
    publicAgents: PublicAgents,
    publicGatewayRules: PublicGatewayRules,
    publicWalletRules: PublicWalletRules,
    publicGatewayApis: PublicGatewayApis,
    publicTgBots: PublicTgBots,
    publicTgUnknownChats: PublicTgUnknownChats,
    publicTgSessions: PublicTgSessions,
    publicTgSessionChats: PublicTgSessionChats,
    publicTgSessionMessages: PublicTgSessionMessages,
    publicGateways: PublicGateways,
    publicGatewaySettings: PublicGatewaySettings,
    publicScraperScenarios: PublicScraperScenarios,
    publicProxyLists: PublicProxyLists,
    publicProxies: PublicProxies,
    publicMerchants: PublicMerchants,
    publicMerchantTerminals: PublicMerchantTerminals,
    publicMerchantTerminalBalances: PublicMerchantTerminalBalances,
    publicWallets: PublicWallets,
    publicCommissions: PublicCommissions,
    publicAppeals: PublicAppeals,
    publicAppealHasComments: PublicAppealHasComments,
    publicAppealHasDocuments: PublicAppealHasDocuments,
    payinInstances: PayinInstances,
    payinEvents: PayinEvents,
    payoutInstances: PayoutInstances,
    payoutEvents: PayoutEvents,
    payoutDocuments: PayoutDocuments,
    callbackprocessorUrlCallbacks: CallbackprocessorUrlCallbacks,
    accountingSystemAccounts: AccountingSystemAccounts,
    accountingExternalTransactions: AccountingExternalTransactions,
    accountingGatewayTransactions: AccountingGatewayTransactions,
    accountingWalletTransfers: AccountingWalletTransfers,
    accountingGatewayWalletTransfers: AccountingGatewayWalletTransfers,
    accountingSystemTransactions: AccountingSystemTransactions,
    accountingExpensesTransactions: AccountingExpensesTransactions,
    accountingRevenueTransactions: AccountingRevenueTransactions
};

export class ServerBuilder {
    #serverData = {};

    constructor(serverData) {
        this.#serverData = serverData;
    }

    build() {
        const server = {};
        Object.entries(ServerConfig).forEach(([key, Server]) => {
            server[key] = new Server(this.#serverData);
        });
        return server;
    }
}

